import React from "react";
import ReactQuill from "react-quill";
import "react-quill/dist/quill.snow.css";

// -------------------------------
// Quill Modules & Formats
// -------------------------------

const modules = {
  toolbar: [
    [{ header: [1, 2, 3, 4, 5, 6, false] }],
    ["bold", "italic", "underline", "strike", "blockquote", "code-block"],
    [{ list: "ordered" }, { list: "bullet" }],
    [{ indent: "-1" }, { indent: "+1" }],
    [{ color: [] }, { background: [] }],
    [{ align: [] }],
    ["link", "image", "video"],
    ["clean"],
  ],
};

const formats = [
  "header",
  "bold",
  "italic",
  "underline",
  "strike",
  "blockquote",
  "code-block",
  "list",
  "bullet",
  "indent",
  "color",
  "background",
  "align",
  "link",
  "image",
  "video",
];

// -------------------------------
// Rich Text Editor Component
// -------------------------------

const RichTextEditor = ({
  value,
  onChange,
  placeholder = "Enter agreement details...",
  readOnly = false,
}) => {
  return (
    <div className="mb-3">
      <label className="form-label fw-semibold">Agreement Content (Details)</label>

      {/* Editor Border Wrapper */}
      <div>
        <ReactQuill
          theme="snow"
          value={value}
          onChange={onChange}
          modules={modules}
          formats={formats}
          placeholder={placeholder}
          readOnly={readOnly}
          style={{
            height: "350px",
          }}
        />
      </div>
    </div>
  );
};

export default RichTextEditor;
